module.exports = __webpack_public_path__ + "static/media/icon-intersection.3bfe28b5.svg";